var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BDBE07;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{fill:url(#SVGID_4_);}\r\n\t.st6{fill:url(#SVGID_5_);}\r\n\t.st7{fill:url(#SVGID_6_);}\r\n\t.st8{fill:url(#SVGID_7_);}\r\n\t.st9{fill:url(#SVGID_8_);}\r\n\t.st10{fill:url(#SVGID_9_);}\r\n\t.st11{fill:url(#SVGID_10_);}\r\n\t.st12{fill:#FFFFFF;}\r\n\t.st13{opacity:0.2;fill:#FFFFFF;}\r\n\t.st14{fill:#28B5BC;}\r\n\t.st15{opacity:0.1;fill:url(#SVGID_11_);}\r\n\t.st16{fill:#3563AC;}\r\n\t.st17{fill:url(#SVGID_12_);}\r\n\t.st18{fill:url(#SVGID_13_);}\r\n\t.st19{fill:url(#SVGID_14_);}\r\n\t.st20{fill:url(#SVGID_15_);}\r\n\t.st21{fill:url(#SVGID_16_);}\r\n\t.st22{fill:url(#SVGID_17_);}\r\n\t.st23{fill:url(#SVGID_18_);}\r\n\t.st24{fill:url(#SVGID_19_);}\r\n\t.st25{fill:url(#SVGID_20_);}\r\n\t.st26{fill:url(#SVGID_21_);}\r\n\t.st27{fill:url(#SVGID_22_);}\r\n\t.st28{fill:url(#SVGID_23_);}\r\n\t.st29{fill:url(#SVGID_24_);}\r\n\t.st30{fill:url(#SVGID_25_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.2531,
    y1: 25.9978,
    x2: 43.7469,
    y2: 25.9978
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28B5BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    style: {
      stopColor: "#2097A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    style: {
      stopColor: "#16728A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    style: {
      stopColor: "#0F5776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    style: {
      stopColor: "#0B476A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#094166"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.19,41.05c-0.39,0.02-0.78,0.03-1.17,0.07c-0.76,0.09-1.27,0.59-1.72,1.15c-0.3,0.37-0.58,0.76-0.9,1.11 c-0.9,1-1.54,1.13-2.77,0.58c-0.59-0.26-1.18-0.53-1.78-0.78c-0.66-0.28-1.31-0.18-1.94,0.09c-0.57,0.25-1.13,0.55-1.7,0.79 c-1.15,0.48-1.85,0.26-2.69-0.75c-0.42-0.5-0.82-1.02-1.26-1.51c-0.45-0.51-1.06-0.69-1.72-0.71c-0.57-0.02-1.15,0.01-1.73-0.01 c-0.47-0.02-0.95-0.07-1.36-0.34c-0.55-0.36-0.75-0.93-0.91-1.53c-0.16-0.61-0.3-1.23-0.46-1.84c-0.18-0.67-0.62-1.12-1.22-1.43 c-0.6-0.31-1.21-0.58-1.8-0.9c-0.54-0.3-1.02-0.7-1.07-1.36c-0.03-0.5,0.05-1.02,0.13-1.52c0.08-0.53,0.24-1.05,0.32-1.58 c0.13-0.85-0.3-1.51-0.8-2.16c-0.42-0.54-0.83-1.11-1.18-1.7c-0.35-0.59-0.23-1.21,0.12-1.75c0.36-0.56,0.76-1.09,1.19-1.59 c0.72-0.84,0.8-1.77,0.53-2.79c-0.14-0.56-0.24-1.13-0.32-1.7c-0.14-0.99,0.4-1.6,1.22-2.03c0.53-0.27,1.06-0.55,1.6-0.8 c0.85-0.39,1.23-1.11,1.44-1.97c0.17-0.69,0.35-1.37,0.57-2.04c0.24-0.72,0.83-1.04,1.55-1.09c0.71-0.05,1.42-0.06,2.12-0.06 c0.87-0.01,1.55-0.39,2.08-1.07c0.38-0.5,0.77-1,1.2-1.45c0.8-0.81,1.45-0.86,2.44-0.45c0.56,0.23,1.1,0.5,1.65,0.77 c0.86,0.43,1.69,0.3,2.52-0.1c0.55-0.26,1.09-0.53,1.65-0.76c1.03-0.41,1.75,0.02,2.39,0.76c0.45,0.52,0.87,1.06,1.32,1.58 c0.45,0.51,1.05,0.69,1.7,0.71c0.56,0.02,1.13-0.01,1.7,0.01c0.32,0.01,0.65,0.06,0.97,0.15c0.77,0.21,1.1,0.83,1.29,1.54 c0.15,0.55,0.29,1.11,0.41,1.67c0.19,0.86,0.68,1.46,1.47,1.85c0.63,0.3,1.27,0.6,1.87,0.97c0.79,0.48,1.05,1.26,0.86,2.16 c-0.17,0.79-0.33,1.58-0.44,2.38c-0.09,0.65,0.23,1.19,0.61,1.69c0.41,0.54,0.83,1.07,1.21,1.62c0.45,0.64,0.48,1.33,0.05,1.99 c-0.37,0.56-0.78,1.09-1.2,1.62c-0.52,0.66-0.87,1.36-0.69,2.23c0.08,0.39,0.17,0.78,0.25,1.17c0.07,0.37,0.16,0.74,0.2,1.12 c0.09,0.79-0.18,1.42-0.88,1.83c-0.5,0.29-1.01,0.59-1.55,0.8c-1.21,0.47-1.74,1.4-1.95,2.61c-0.08,0.48-0.21,0.95-0.36,1.41 c-0.28,0.84-0.9,1.27-1.77,1.31c-0.44,0.02-0.88,0-1.31,0C34.19,41.03,34.19,41.04,34.19,41.05z M21.82,33.67 c0.65,0.01,1.17-0.24,1.61-0.67c3.64-3.64,7.28-7.28,10.92-10.92c0.71-0.71,0.87-1.67,0.44-2.56c-0.46-0.93-1.54-1.42-2.6-1.11 c-0.55,0.16-0.91,0.56-1.29,0.94c-2.94,2.94-5.87,5.87-8.81,8.81c-0.16,0.16-0.31,0.17-0.47,0.01c-0.97-0.97-1.94-1.95-2.91-2.92 c-0.55-0.54-1.24-0.73-1.96-0.57c-0.89,0.2-1.49,0.78-1.69,1.69c-0.18,0.79,0.06,1.48,0.63,2.05c1.54,1.54,3.09,3.09,4.63,4.63 C20.72,33.46,21.23,33.69,21.82,33.67z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M21.82,33.67c-0.59,0.02-1.1-0.22-1.52-0.64c-1.55-1.54-3.09-3.08-4.63-4.63c-0.57-0.57-0.8-1.26-0.63-2.05 c0.2-0.91,0.8-1.49,1.69-1.69c0.73-0.16,1.42,0.03,1.96,0.57c0.98,0.97,1.94,1.94,2.91,2.92c0.17,0.17,0.31,0.16,0.47-0.01 c2.93-2.94,5.87-5.87,8.81-8.81c0.38-0.38,0.74-0.78,1.29-0.94c1.06-0.31,2.14,0.18,2.6,1.11c0.44,0.9,0.27,1.85-0.44,2.56 c-3.64,3.64-7.28,7.28-10.92,10.92C22.99,33.44,22.47,33.69,21.82,33.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckout);
export default __webpack_public_path__ + "static/media/successCheckout.fc436c570c9a6fd2f3327e95cb24c38b.svg";
export { ForwardRef as ReactComponent };